import React from "react";

import { Stack } from "@mui/system";

import Button from "@src/multiCustodian/components/MUI/Button/Button";
import Modal from "@src/sharedComponents/Modal/Modal";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./ModalMaintenance.module.css";

const texts = {
  modalTitle: "Undergoing Maintenance",
  modalBody:
    "This feature is temporarily unavailable. If you would like to initiate a raise cash request, please create a task for the Trading team.",
};

export const ModalMaintenance = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  return (
    <Modal
      isOpen={isOpen}
      closeModal={() => {}}
      modalStyle={{ width: "432px" }}
      className={styles.container}
    >
      <Stack sx={{ gap: "4px" }}>
        <Text variant="title2">{texts.modalTitle}</Text>
        <Text variant="body">{texts.modalBody}</Text>
      </Stack>
      <Button
        sx={{ width: "100%", marginTop: "24px" }}
        onClick={onClose}
        variant="outlined"
        buttonType="primary"
        text="Close"
      />
    </Modal>
  );
};
